export const objToSearch = (obj) => {
    const keys = Object.keys(obj)
    const arr = keys.reduce((a, c) => {
        a.push(`${c}=${obj[c]}`)
        return a
    }, [])
    return '?' + arr.join('&')
}